import { CallsFilter } from 'entities/reports/calls/calls-filter';
import { Box } from '@mui/material';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useSearchParams } from 'react-router-dom';
import { CallsList } from 'entities/reports/calls/calls-list';
import { useCallsList } from 'entities/reports/calls/calls.hook';

const RELATED_FIELDS = ['fromPhone', 'toPhone', 'companyId', 'userId', 'atsDuration', 'taskType', 'startDate', 'endDate'];

export const Calls = () => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();

  const getCallsSearchParams = () => {
    const newParams = new URLSearchParams();
    
    searchParams.forEach((value, key) => {
      if (RELATED_FIELDS.includes(key)) {
        newParams.append(key, value);
      }
    });
    
    return newParams;
  };

  const collection = useCallsList(paging, getCallsSearchParams());

  return (
    <Box mt={2}>
      <Box mb={1}>
        <CallsFilter />
      </Box>
      <CallsList collection={collection} paging={paging} onChangePaging={setPaging} />
    </Box>
  );
};